// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import NotFound from '@/components/NotFound'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  computed: {
    ViewComponent () {
      return routes[this.currentRoute] || NotFound
    }
  },
})



// WEBPACK FOOTER //
// ./src/main.js